import {
  GET_BANK_LIST,
  GET_DETAIL_STRUCTURE,
  GET_EMPLOYEE_CHART,
  GET_FOCUS_POSITION,
  GET_FOCUS_POSITION_EMPLOYEE,
  GET_LIST_DIRECTORATE,
  GET_LIST_DIVISION,
  GET_LIST_EMPLOYEE,
  GET_LIST_EMPLOYEE_LIMIT,
  GET_LIST_JOB,
  GET_LIST_ORGANIZATION,
  GET_LIST_ORGANIZATION_LIMIT,
  GET_STRUCTURE,
  SET_PAGINATION_EMPLOYEE,
  SET_PAGINATION_STRUCTURE
} from "redux/actions/organization";
import { GET_REGION_LIST } from "redux/actions/wla";

const initialState = {
  employee: [],
  structure: [],
  employee_limit: [],
  structure_limit: [],
  total_employee: 0,
  totalStructure: 0,
  detail_structure: [],
  chart: [],
  employee_chart: [],
  list_job: [],
  list_focus_position: [],
  list_region: [],
  list_directorate: [],
  list_division: [],
  paginationEmployee: {
    limit: 10,
    offset: 0,
  },
  paginationStructure: {
    limit: 10,
    offset: 0
  }
};
// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, { type, payload, update }) => {
  switch (type) {
    case GET_DETAIL_STRUCTURE: {
      return {
        ...state,
        detail_structure: payload
      };
    }
    case GET_LIST_EMPLOYEE: {
      return {
        ...state,
        employee: payload.data
      };
    }
    case GET_LIST_EMPLOYEE_LIMIT: {
      return {
        ...state,
        employee_limit: payload.data,
        total_employee: payload.count
      };
    }
    case GET_BANK_LIST: {
      return {
        ...state,
        bank_list: payload
      };
    }
    case GET_LIST_ORGANIZATION: {
      if (update) {
        const products = [...state.structure];
        const index = products.findIndex(
          product => product.organization_id === payload.organization_id
        );
        payload.masalah_tantangan = payload.masalah_tantangan || [];

        // state.structure[index] = payload;
        products[index] = { ...products[index], ...payload };
        return {
          ...state,
          structure: products
        };
      }
      return {
        ...state,
        structure: payload.data
      };
    }
    case GET_LIST_ORGANIZATION_LIMIT: {
      return {
        ...state,
        structure_limit: payload.data,
        totalStructure: payload.count
      };
    }
    case GET_STRUCTURE: {
      return {
        ...state,
        chart: payload.map(val => ({
          ...val,
          "Organization ID": val.organization_id,
          Nama: val.name,
          Tag: val.tag,
          "Job Grade": val.job_grade,
          Purpose: val.purpose,
          "Report to": val.report_to_id,
          "Job Level": val.job_level
        })),
        list_focus_position: payload.map(val => ({
          "Organization ID": val.organization_id,
          Nama: val.name,
          Tag: val.tag,
          "Job Grade": val.job_grade,
          Purpose: val.purpose,
          "Report to": val.report_to_id,
          "Job Level": val.job_level
        }))
      };
    }
    case GET_EMPLOYEE_CHART: {
      return {
        ...state,
        employee_chart: payload
      };
    }
    case GET_LIST_JOB: {
      return {
        ...state,
        list_job: payload
      };
    }
    case GET_FOCUS_POSITION: {
      return {
        ...state,
        chart: payload.map(val => ({
          ...val,
          "Organization ID": val.organization_id,
          Nama: val.name,
          Tag: val.tag,
          "Job Grade": val.job_grade,
          Purpose: val.purpose,
          "Report to": val.report_to_id,
          "Job Level": val.job_level
        }))
      };
    }
    case GET_FOCUS_POSITION_EMPLOYEE: {
      return {
        ...state,
        employee_chart: payload
      };
    }
    case GET_REGION_LIST: {
      if (payload?.insert_data) {
        state.list_region.push(payload.data);
        return state;
      }
      if (payload?.update_data) {
        state.list_region[payload.id] = {
          region_id: state.list_region[payload.id].region_id,
          ...payload.data
        };
        return state;
      }
      return {
        ...state,
        list_region: payload
      };
    }
    case GET_LIST_DIRECTORATE: {
      if (payload?.insert_data) {
        state.list_directorate.push(payload.data);
        return state;
      }
      if (payload?.update_data) {
        state.list_directorate[payload.id] = payload.data;
        return state;
      }
      return {
        ...state,
        list_directorate: payload
      };
    }
    case GET_LIST_DIVISION: {
      return {
        ...state,
        list_division: payload
      };
    }
    case SET_PAGINATION_EMPLOYEE: {
      return {
        ...state,
        paginationEmployee: {
          ...state.paginationEmployee,
          ...payload,
        },
      };
    }
    case SET_PAGINATION_STRUCTURE: {
      return {
        ...state,
        paginationStructure: {
          ...state.paginationStructure,
          ...payload,
        },
      };
    }

    default:
      return state;
  }
};
